<template>
  <h1>Not to be used within Quoting Portal</h1>
</template>

<script>
export default {
  name: "CustomerSelector"
}
</script>

<style scoped>

</style>